export const IDENTIFICATION_TYPES_GET_REQUESTING = 'IDENTIFICATION_TYPES_GET_REQUESTING';
export const IDENTIFICATION_TYPES_GET_SUCCESS = 'IDENTIFICATION_TYPES_GET_SUCCESS';
export const IDENTIFICATION_TYPES_GET_ERROR = 'IDENTIFICATION_TYPES_GET_ERROR';